import React from 'react';

interface ImageProps {
  src: string;
  width: number;
  height: number;
  alt: string;
  className?: string;
}

const Image: React.FC<ImageProps> = ({ src, width, height, alt, className }) => {
  return (
    <img
      src={src}
      width={width}
      height={height}
      alt={alt}
      className={className}
      style={{ objectFit: 'cover' }} // Optional: Set object-fit to cover
    />
  );
};

export default Image;
